// extracted by mini-css-extract-plugin
export var productImage = "_ph-1";
export var viewLink = "_ph-2";
export var wishlistItem = "_ph-0";